export default () => ({
	init() {
		setTimeout(() => {
			this.$refs.myform.submit();
		}, 1000); // Automatically submit the form after 1 second
	}
})